import React from 'react';

import Dropdown from 'components/Dropdown';
import BookingStatus from 'components/BookingStatus';
import IconButton from 'components/IconButton';
import {withScrollbar} from 'components/withScrollbar';
import closeButton from 'assets/icons/close-button.svg';

import {BookingStatusesDescriptions} from 'ducks/bookings/list';

import './styles.css';

class BookingStatusesTooltip extends React.Component<any> {
  containerRef: any = React.createRef();

  componentDidMount() {
    this.props.setScrollableContainerRef(this.containerRef.current);
  }

  render() {
    const {VerticalScrollbar, isVisible, position} = this.props;

    return (
      <Dropdown isOpen={isVisible} position={position} appendToBody={true}>
        <div className="BookingStatusesTooltip colab-medium-border-radius">
          <div className="BookingStatusesTooltip__header colab-centered-v colab-sidepadding-2 colab-row-space-between">
            <div className="colab-bold">Status quick check</div>
            <div>
              <IconButton
                src={closeButton}
                alt="close"
                onClick={this.props.onClose}
              />
            </div>
          </div>
          <div className="BookingStatusesTooltip__content">
            <div className="BookingStatusesList" ref={this.containerRef}>
              {BookingStatusesDescriptions.map(bookingStatus => (
                <div
                  className="BookingStatusList__item"
                  key={bookingStatus.label}>
                  <div className="BookingStatusList__item__label colab-centered-v">
                    <BookingStatus status={bookingStatus.label} />
                  </div>
                  <div className="BookingStatusList__item__description colab-centered-v">
                    {bookingStatus.description}
                  </div>
                </div>
              ))}
              {VerticalScrollbar}
            </div>
          </div>
        </div>
      </Dropdown>
    );
  }
}

export default withScrollbar(BookingStatusesTooltip);
